var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{class:_vm.classFan,style:(_vm.styleFan),attrs:{"width":_vm.size,"height":_vm.size,"src":_vm.srcFan,"contain":""}})}
var staticRenderFns = []

export { render, staticRenderFns }